module.exports = __webpack_public_path__ + "static/media/eye.5f17534c.svg";